<div style="display: grid; grid-template-columns: 200px 1fr;">
	<div style="margin-top: 10px;">
		<span style="font-weight: bold;">Select events to be logged</span>
		<!--<div class="form-check event-type-checkbox">
			<input class="form-check-input" type="checkbox" value="" id="log-admin-settings" [(ngModel)]="settings.log_admin_actions" (change)="saveAuditLogSettings()">
			<label class="form-check-label" for="log-admin-settings">
				Admin Changes
			</label>
		</div>-->
		<div class="form-check event-type-checkbox">
			<input class="form-check-input" type="checkbox" value="" id="log-login-actions" [(ngModel)]="settings.log_login_actions" (change)="saveAuditLogSettings()">
			<label class="form-check-label" for="log-login-actions">
				User Login/Logout
			</label>
		</div>
		<div class="form-check event-type-checkbox">
			<input class="form-check-input" type="checkbox" value="" id="log-password-actions" [(ngModel)]="settings.log_password_actions" (change)="saveAuditLogSettings()">
			<label class="form-check-label" for="log-password-actions">
				Password Changes
			</label>
		</div>
		<div class="form-check event-type-checkbox">
			<input class="form-check-input" type="checkbox" value="" id="log-network-change-actions" [(ngModel)]="settings.log_network_change_actions" (change)="saveAuditLogSettings()">
			<label class="form-check-label" for="log-network-change-actions">
				Network Changes
			</label>
		</div>
	</div>
	<div>
		<p-tabView [(activeIndex)]="activeIndex" #tabview>

			<p-tabPanel header="Audit Log" headerStyleClass="config-tab" [selected]="true">
				<audit-log-table [logType]="'AuditLogEntry'"></audit-log-table>
			</p-tabPanel>

			<p-tabPanel header="Network Change Log" headerStyleClass="config-tab">
				<audit-log-table [logType]="'NetworkChangeEntry'"></audit-log-table>
			</p-tabPanel>

		</p-tabView>
	</div>
</div>
